import React, { createContext, useContext, useEffect } from "react";

// Tema único: vermelho dinâmico. (setTheme existe só por compatibilidade com telas antigas.)
const ThemeContext = createContext({ theme: "red", setTheme: () => {}, isAuto: false });

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove("theme-blue", "theme-gold");
    document.documentElement.classList.add("theme-red");
    try { localStorage.setItem("pkx_theme", "red"); } catch (e) { /* ok */ }
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: "red", setTheme: () => {}, isAuto: false }}>
      {children}
    </ThemeContext.Provider>
  );
}

export { ThemeContext };
export const useTheme = () => useContext(ThemeContext);
